var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acd_buttonSave1LkT4 {\n  display: inline-block;\n  line-height: 35px;\n  padding: 0px 20px;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n  border: none;\n  top: 10px;\n  cursor: pointer;\n  position: relative;\n  background: #ec6762; }\n  .acd_buttonSave1LkT4:hover {\n    background: #ec6762d1; }\n\n.acd_buttonLoad1HOfw {\n  background: url(" + escape(require("../images/progress-white.svg")) + ") no-repeat;\n  background-size: contain;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  font-size: 0;\n  vertical-align: middle;\n  margin-left: 5px; }\n", ""]);

// exports
exports.locals = {
	"buttonSave": "acd_buttonSave1LkT4",
	"buttonLoad": "acd_buttonLoad1HOfw"
};